import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 30"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#3C492F",
  d: "M15 15.145q-2.268 0-3.713-1.42-1.443-1.421-1.443-3.652 0-2.232 1.444-3.653T15 5t3.712 1.42 1.444 3.653-1.444 3.652T15 15.145M4 26v-3.179q0-1.285.653-2.198a4.2 4.2 0 0 1 1.685-1.386q2.302-1.015 4.417-1.522A18 18 0 0 1 15 17.208q2.13 0 4.228.524t4.4 1.505a4.13 4.13 0 0 1 1.719 1.386q.653.914.653 2.198V26zm2.063-2.029h17.875v-1.15q0-.54-.327-1.031a2.06 2.06 0 0 0-.808-.727q-2.2-1.05-4.022-1.437a18 18 0 0 0-3.781-.39q-1.959 0-3.816.39-1.856.389-4.021 1.437-.482.237-.791.727t-.31 1.031zM15 13.116q1.341 0 2.217-.862t.877-2.181q0-1.32-.877-2.182Q16.341 7.03 15 7.03t-2.217.862-.877 2.182.877 2.18q.876.863 2.217.863"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }